import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useMemo } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import { calcPrecentage } from "./ElectionEventStats";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { useTranslation } from "react-i18next";
var usePollsStats = function (props) {
    var eligibleVotersCount = props.eligibleVotersCount, enrolledVotersCount = props.enrolledVotersCount, electionsCount = props.electionsCount, startedVoteCount = props.startedVoteCount, notStartedVotesCount = props.notStartedVotesCount, openVotesCount = props.openVotesCount, notOpenVotesCount = props.notOpenVotesCount, closedVotesCount = props.closedVotesCount, notClosedVotesCount = props.notClosedVotesCount, initializeCount = props.initializeCount, notInitializeCount = props.notInitializeCount, votingStats = props.votingStats;
    var t = useTranslation().t;
    var authContext = useContext(AuthContext);
    var showTotalInitialized = authContext.isAuthorized(true, authContext.tenantId, IPermissions.MONITOR_POSTS_INITIALIZED_THE_SYSTEM);
    var showPostsOpenedVoting = authContext.isAuthorized(true, authContext.tenantId, IPermissions.MONITOR_POSTS_ALREADY_OPENED_VOTING);
    var showPostsClosedVoting = authContext.isAuthorized(true, authContext.tenantId, IPermissions.MONITOR_POSTS_ALREADY_CLOSED_VOTING);
    var showPostsStartVoting = authContext.isAuthorized(true, authContext.tenantId, IPermissions.MONITOR_POSTS_STARTED_VOTING);
    var showVotersVoted = authContext.isAuthorized(true, authContext.tenantId, IPermissions.MONITOR_VOTERS_WHO_VOTED);
    var pollsSection = useMemo(function () {
        return {
            show: showTotalInitialized ||
                showPostsOpenedVoting ||
                showPostsClosedVoting ||
                showPostsStartVoting ||
                showVotersVoted,
            title: t("monitoringDashboardScreen.polls.title"),
            stats: [
                {
                    show: showTotalInitialized,
                    title: t("monitoringDashboardScreen.polls.initializedSystems"),
                    items: [
                        {
                            show: showTotalInitialized,
                            icon: _jsx(CheckCircleOutlineIcon, {}),
                            count: initializeCount,
                            percentage: calcPrecentage(initializeCount, electionsCount),
                        },
                        {
                            icon: _jsx(CancelOutlinedIcon, {}),
                            count: notInitializeCount,
                            percentage: calcPrecentage(notInitializeCount, electionsCount),
                        },
                    ],
                },
                {
                    show: showPostsOpenedVoting,
                    title: t("monitoringDashboardScreen.polls.votingOpened"),
                    items: [
                        {
                            icon: _jsx(CheckCircleOutlineIcon, {}),
                            count: openVotesCount,
                            percentage: calcPrecentage(openVotesCount, electionsCount),
                        },
                        {
                            icon: _jsx(CancelOutlinedIcon, {}),
                            count: notOpenVotesCount,
                            percentage: calcPrecentage(notOpenVotesCount, electionsCount),
                        },
                    ],
                },
                {
                    show: showPostsClosedVoting,
                    title: t("monitoringDashboardScreen.polls.votingClosed"),
                    items: [
                        {
                            icon: _jsx(CheckCircleOutlineIcon, {}),
                            count: closedVotesCount,
                            percentage: calcPrecentage(closedVotesCount, electionsCount),
                        },
                        {
                            icon: _jsx(CancelOutlinedIcon, {}),
                            count: notClosedVotesCount,
                            percentage: calcPrecentage(notClosedVotesCount, electionsCount),
                        },
                    ],
                },
                {
                    show: showPostsStartVoting,
                    title: t("monitoringDashboardScreen.polls.votingStarted"),
                    items: [
                        {
                            icon: _jsx(CheckCircleOutlineIcon, {}),
                            count: startedVoteCount,
                            percentage: calcPrecentage(startedVoteCount, electionsCount),
                        },
                        {
                            icon: _jsx(CancelOutlinedIcon, {}),
                            count: notStartedVotesCount,
                            percentage: calcPrecentage(notStartedVotesCount, electionsCount),
                        },
                    ],
                },
                {
                    show: showVotersVoted,
                    title: t("monitoringDashboardScreen.polls.voterTurnout"),
                    items: [
                        {
                            icon: _jsx(MarkEmailReadOutlinedIcon, {}),
                            count: votingStats.votedCount,
                            percentage: calcPrecentage(votingStats.votedCount, eligibleVotersCount),
                        },
                    ],
                },
            ],
        };
    }, [
        showTotalInitialized,
        showPostsOpenedVoting,
        showPostsClosedVoting,
        showPostsStartVoting,
        showVotersVoted,
        votingStats,
        eligibleVotersCount,
        electionsCount,
        startedVoteCount,
        notStartedVotesCount,
        openVotesCount,
        notOpenVotesCount,
        closedVotesCount,
        notClosedVotesCount,
        initializeCount,
        notInitializeCount,
    ]);
    return { pollsSection: pollsSection };
};
export default usePollsStats;
